import { useEffect, useState } from "react";
import { MapPin } from "lucide-react";
import { money } from "@/lib/api";
import { SlideToAccept } from "@/components/SlideToAccept";

export const OfferCard = ({ offer, onAccept, onDecline, busy }) => {
  const [left, setLeft] = useState(offer.seconds_left);
  useEffect(() => {
    setLeft(offer.seconds_left);
    const t = setInterval(() => setLeft((s) => Math.max(0, s - 1)), 1000);
    return () => clearInterval(t);
  }, [offer.id, offer.seconds_left]);
  const pct = (left / (offer.offer_seconds || 60)) * 100;

  const delivery = offer.kind === "delivery";
  return (
    <div className="fixed inset-0 z-[1300] flex items-end justify-center bg-black/60 p-4 backdrop-blur-sm sm:items-center" data-testid="incoming-request-overlay">
      <div className="lux-card w-full max-w-md !border-amber-400/40 bg-[#121216]/95 p-6 shadow-2xl backdrop-blur-xl fade-up">
        <div className="flex items-center justify-between">
          {delivery ? <p data-testid="offer-delivery-badge" className="rounded-full bg-amber-400 px-3 py-1 text-xs font-bold tracking-[0.2em] text-black">DELIVERY</p> : <p className="lux-eyebrow">New ride request</p>}
          <span data-testid="offer-countdown" className="font-mono text-2xl text-amber-300 tabular-nums">{left}s</span>
        </div>
        <div className="mt-3 h-1 overflow-hidden rounded-full bg-zinc-800">
          <div className="h-full bg-gradient-to-r from-amber-200 to-amber-500 transition-[width] duration-1000 ease-linear" style={{ width: `${pct}%` }} />
        </div>
        <div className="mt-6 space-y-3 text-sm">
          <p className="flex gap-2 text-zinc-200"><MapPin className="h-4 w-4 shrink-0 text-amber-400" /><span data-testid="offer-pickup">{delivery ? `${offer.delivery?.business_name} · ` : ""}{offer.pickup.address}</span></p>
          <p className="pl-6 text-zinc-400">{offer.stops.length} stop{offer.stops.length > 1 ? "s" : ""} · final: {offer.stops[offer.stops.length - 1].address}</p>
        </div>
        <div className="mt-6 grid grid-cols-3 gap-2 text-center">
          <div className="rounded-lg bg-white/[0.03] p-3"><p className="lux-eyebrow !text-[0.55rem]">To pickup</p><p className="mt-1 font-serif text-lg text-amber-50" data-testid="offer-distance">{offer.offer?.distance_miles ?? "—"} mi</p></div>
          <div className="rounded-lg bg-white/[0.03] p-3"><p className="lux-eyebrow !text-[0.55rem]">Trip</p><p className="mt-1 font-serif text-lg text-amber-50">{offer.trip_miles} mi</p></div>
          <div className="rounded-lg bg-white/[0.03] p-3"><p className="lux-eyebrow !text-[0.55rem]">Fare</p><p className="mt-1 font-serif text-lg text-amber-50" data-testid="offer-fare">{money(offer.fare.total)}</p></div>
        </div>
        <div className="mt-6 space-y-3">
          <SlideToAccept testId="offer-accept-slider" busy={busy} disabled={left === 0} onAccept={onAccept} />
          <button data-testid="decline-request-button" disabled={busy} onClick={onDecline} className="btn-outline-gold w-full">Decline</button>
        </div>
      </div>
    </div>
  );
};
